import styled from "styled-components";

export const BottomSheet = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  padding: 10px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  transition: transform 0.5s ease-in-out;

  &.bottom-sheet-open {
    transform: translateY(0);
  }

  &.bottom-sheet-close {
    transform: translateY(100%);
  }
`;

export const SheetContainer = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 850px;
  width: 100%;
`;

export const SheetHeader = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 -5px;
  @media (min-width: 576px) {
    flex-direction: row;
  }
`;

export const SheetTitle = styled.h2`
  color: #000;
  display: flex;
  align-items: center;
  margin: 0 5px !important;
  .count {
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    margin-left: 5px;
  }
  .text + .count {
    margin-left: 5px;
  }
`;
export const SheetWarning = styled.div`
  margin: 0 5px;
  .warn {
    font-size: 12px;
    line-height: 20px;
    display: block;
    color: #e9242a;
  }
`;

export const SheetContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media (min-width: 768px) {
    flex-direction: row;
    column-gap: 10px;
  }
  @media (min-width: 992px) {
    flex-direction: row;
    column-gap: 20px;
  }
`;

export const ProductList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px 10px -5px;
  @media (min-width: 992px) {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
    margin: 0 -10px;
  }
  @media (max-width: 767.98px) {
    width: 100%;
    overflow-x: auto;
    flex-wrap: nowrap;
  }
`;

export const ProductItem = styled.div`
  position: relative;
  width: 100%;
  padding: 5px;
  @media (max-width: 767.98px) {
    max-width: 180px;
    width: 100%;
    margin: 0 auto;
  }
  @media (min-width: 768px) {
    flex: 0 0 25%;
    max-width: 25%;
  }
  @media (min-width: 992px) {
    padding: 10px;
  }
`;

export const ProductCard = styled.div`
  position: relative;
  margin: 0;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  overflow: hidden;
`;

export const ProductAction = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  .btn-close {
    cursor: pointer;
    height: 28px;
    width: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      width: 28px;
      height: 28px;
    }
  }
`;

export const ProductImage = styled.div`
  width: 100%;
`;

export const ProductTitle = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 10px;
  white-space: nowrap;
  padding: 10px;
`;

export const EmptyProduct = styled.div`
  cursor: pointer;
  width: 100%;
  height: 100%;
  border: 1px dashed rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 8px;
  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .icon {
    display: flex;
    text-align: center;
    font-size: 40px;
  }
  .text {
    font-size: 16px;
    line-height: 20px;
    color: #000;
  }
  @media (max-width: 767.98px) {
    max-width: 180px;
    aspect-ratio: 16 / 9;
  }
`;

export const CompareAction = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
  @media (min-width: 992px) {
    width: auto;
    flex-direction: column;
  }
`;
export const CompareItemAction = styled.div`
  cursor: pointer;
  padding: 5px 0;
  .btn {
    min-width: 120px;
    width: 100%;
  }
`;
export const CloseCompare = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
  z-index: 2;
  svg {
    width: 12px;
    height: 12px;
  }
  &:hover {
    svg {
      fill: #e9242a;
    }
  }
`;
